import { render } from "./CreditosDescuentos.vue?vue&type=template&id=443a2454"
import script from "./CreditosDescuentos.vue?vue&type=script&lang=js"
export * from "./CreditosDescuentos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__